var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"100%","height":"100%","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9 6H6V20H19V6H16V7.5H9V6ZM9 11.25V12.75H16V11.25H9ZM9 15.25V16.75H16V15.25H9Z"}}),_c('path',{attrs:{"d":"M10 4H15V6.5H10V4Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }